var render, staticRenderFns
import script from "./storeSettings.vue?vue&type=script&lang=js"
export * from "./storeSettings.vue?vue&type=script&lang=js"
import style0 from "./storeSettings.vue?vue&type=style&index=0&id=40d746c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d746c0",
  null
  
)

export default component.exports